import React from 'react';
import moment from 'moment/moment';
import {DefaultCell} from '../Table';

const OpenItems = ({
  action,
  setModalStatus,
  setChosenCorrectiveAction,
  rowIndex,
  cellKeys,
}) => (
  <tr
    className='table-row'
    style={{
      gridTemplateColumns: `repeat(${cellKeys.length}, 1fr)`,
    }}
    key={action.id}
    onClick={() => {
      setModalStatus(true);
      setChosenCorrectiveAction(action);
    }}
  >
    <DefaultCell
      value={
        action?.created_at
          ? moment.parseZone(action.created_at).format('MM/DD/YYYY')
          : '---'
      }
      index={'created_at'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.facility_title || '---'}
      index={'facility_title'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.equipment_type_title || '---'}
      index={'equipment_type_title'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.equipment_title || '---'}
      index={'equipment_title'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={`${action.inspection_title ? action.inspection_title : '---'} / ${action.category_title ? action.category_title : '---'}`}
      index={'inspection_title'}
      rowIndex={rowIndex}
    />

    <DefaultCell
      value={action.discrepancy || '---'}
      index={'discrepancy'}
      rowIndex={rowIndex}
    />

    <DefaultCell
      value={action.comment || '---'}
      index={'comment'}
      rowIndex={rowIndex}
    />
  </tr>
);

export default OpenItems;
